import API from '..';
const ENTITY = 'countries';

export const getItems = () => API.get(`/api/v1/${ENTITY}/`);
